/**
 * Shared dealer-facing notice: freight quotes are estimates and not final until
 * the shipment is booked (rates move with fuel surcharges / carrier changes).
 * Shown anywhere a dealer sees or selects a shipping price.
 */
export function ShippingDisclaimer({ className = '' }: { className?: string }) {
  return (
    <div className={`flex items-start gap-2 p-3 rounded-lg bg-amber-500/10 border border-amber-500/30 ${className}`}>
      <svg className="w-4 h-4 text-amber-500 mt-0.5 shrink-0" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
      </svg>
      <p className="text-xs text-amber-700 dark:text-amber-200/90">
        <strong>Shipping quotes are estimates and not final until the shipment is booked.</strong> Freight rates can change between quote and pickup (carrier fuel surcharges and rate adjustments), so your final shipping charge may differ from the amount shown.
      </p>
    </div>
  );
}

export default ShippingDisclaimer;
